import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { AuthorizationService } from '@src/app/helpers/authorization.service';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Customer } from './model/customer';
import { Project } from '@src/app/models/project';
import { Projecttemplate } from './model/projecttemplate';
import { ProjecttemplatelistService } from './service/projecttemplatelist.service';
import { Customerdeal } from '@src/app/models/customerdeal';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-projecttemplatelist',
  templateUrl: './projecttemplatelist.component.html',
  styleUrls: ['./projecttemplatelist.component.css']
})
export class ProjecttemplatelistComponent implements OnInit, OnChanges {
  templateList: Projecttemplate[];
  @Input() wizard:boolean;
  @Input() dealId:string;
  dealList:Customerdeal[];
  @Input() customerId:string;
  step: Number;
  choosenTemplate: Projecttemplate;
  newProject: Project;
  @Output() customerList:Customer[];
  startday:Date;
  newEndDate:Date;
  showCustomerCreate:boolean;
  @Output() setProjectload = new EventEmitter<boolean>();
  @Output() projecttoadd = new EventEmitter<Project>();
  @Output() templatelistover = new EventEmitter<boolean>();

  showSpinner:boolean = false;
  showLoader:boolean = false;
  constructor(
    private ptl:ProjecttemplatelistService,
    private auth:AuthorizationService,
    private datastore:DatastoreService,
    private cdr:ChangeDetectorRef
  ) { }
  
  ngOnInit() {
    this.showLoader = true;
    this.step = 1;
    this.choosenTemplate = new Projecttemplate;
    this.templateList = [];
    this.customerList = [];
    if(!this.newProject){  this.newProject = new Project; };
    this.ptl.getProjectTemplates().subscribe(result => {
      function isDone(temp){
        return temp.templatestate === 'Ready'
      }
      this.templateList = result.filter(isDone);
      this.showLoader = false;
      this.showSpinner = false;
      this.templatelistover.emit(false);
      this.cdr.detectChanges();
      console.log('template list from service',result)
    });
    this.datastore.customers$.pipe(untilDestroyed(this)).subscribe(clist => {
      //this.ptl.getCustomers().pipe(untilDestroyed(this)).subscribe(clist => {
      clist.forEach(cust => {
        cust.customerId = cust.customerId.split('_')[0];
      }
      );  
      this.customerList = clist;
      });
    // if(this.customerId){
    //   this.setCustomer(this.customerId);
    // }

  }


  ngOnChanges(changes: SimpleChanges){
    //console.log('ngOnChanges',changes);
    if(!this.newProject){  this.newProject = new Project; };
    if(!this.customerList){
      //this.datastore.customers$.pipe(untilDestroyed(this)).subscribe(clist => {
      //this.ptl.getCustomers().pipe(untilDestroyed(this)).subscribe(clist => {
        this.customerList = this.datastore.customers.getValue();
      //});
    }
    if(changes.customerId && changes.customerId.currentValue && changes.customerId.currentValue != changes.customerId.previousValue){
      this.newProject.customer = changes.customerId.currentValue;
      this.setCustomer(this.newProject.customer);
    }
    if( changes.dealId && changes.dealId.currentValue && changes.dealId.currentValue != changes.dealId.previousValue){
        this.newProject.dealId = changes.dealId.currentValue;
    }
    

    
  }

  setCustomer(customerId:string){
    //get deals for customer
    this.ptl.getDeals(customerId,new Date().toISOString()).pipe(untilDestroyed(this)).subscribe(deals => {
      deals.forEach(d => {
        d.dealId = d.dealId.split('_')[0];
      }
      );
      this.dealList = deals;
    });
  }
  sortCustomers(){
    this.customerList = this.customerList.sort((a,b)=> {
      if(a.title.toLowerCase() < b.title.toLowerCase()) { return -1; }
      if(a.title.toLowerCase() > b.title.toLowerCase()) { return 1; }
      return 0;
    });
  }
  closeModal(){
    this.ngOnInit();
  }
  openCreateCustomer(){
    this.showCustomerCreate = true;
  }
  addCustomer(cust:Customer){
    if(cust){
    this.customerList.push(cust);
    this.sortCustomers();
    this.newProject.customer = cust.customerId;
    }
    this.showCustomerCreate = false;
  }
  chooseTemplate(template:Projecttemplate){
    this.templatelistover.emit(false);
    this.showSpinner = true;
    this.choosenTemplate = template;
    this.startday = new Date(JSON.parse(this.choosenTemplate.recipe).start_date);
    this.newProject = this.choosenTemplate.recipe ? JSON.parse(this.choosenTemplate.recipe) : new Project;
    if(this.dealId){
      this.newProject.dealId = this.dealId.split('_')[0];
    }
    if(this.customerId){
      this.newProject.customer = this.customerId.split('_')[0];
    }
    this.showSpinner = false;
    this.step = 2;

  
  }
  setEndDate(){
    let dt1 = this.startday
    let dt2 = new Date(this.newProject.start_date);
    var diff = Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate()) ) /(1000 * 60 * 60 * 24));
    this.newProject.end_date = this.addDays(new Date(JSON.parse(this.choosenTemplate.recipe).end_date),diff);
    //this.newProject.end_date.setDate(new Date(JSON.parse(this.choosenTemplate.recipe).end_date).getDate()+diff);
  }
  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }
  createProject(){
    this.setProjectload.emit(true) 
   // this.showSpinner = true;

    //TODO: add org and customer details to project
    this.newProject.customername = this.customerList.find(c => c.customerId.split('_')[0] == this.newProject.customer.split('_')[0]).title;
    this.newProject.organizationId = SessionHelper.getChoosenOrg();

    this.ptl.getOrg().pipe(untilDestroyed(this)).subscribe(org => {
      if(this.dealId){
        this.newProject.dealId = this.dealId;
      }
        this.newProject.organizationname = org.organizationname;
        this.newProject.orgdesc = org.orgdesc;
        this.newProject.orgwww = org.www;
        this.newProject.orgemail = org.email;
        this.newProject.orglogourl = org.logourl;
        this.newProject.projectscope = "organization";
        this.newProject.templateId = this.choosenTemplate.templateId;
        this.newProject.customer = this.newProject.customer.split('_')[0];
        this.newProject.created = new Date();
        this.newProject.creator = SessionHelper.getUserSub();
        this.ptl.createProject(this.newProject).pipe(untilDestroyed(this)).subscribe((result) => {
           this.newProject.projectId = result.newProjectId;

           this.datastore.loadProjectDependentData([this.newProject]);
          this.projecttoadd.emit(this.newProject);
          this.newProject = new Project;
          this.choosenTemplate = new Projecttemplate;
          //setTimeout(() => this.auth.refreshPersonAuth(SessionHelper.getUserSub()),2000);
          this.step = 1;

        });
        this.showSpinner = false;

      });

    
  }
}
